"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, use, useId } from "react";
import { cx } from "@/lib/tailwind-utils";
interface SettingsSectionContextValue {
  meta: {
    headingId: string;
  };
}
const SettingsSectionContext = createContext<SettingsSectionContextValue | null>(null);
function useSettingsSection() {
  const ctx = use(SettingsSectionContext);
  if (!ctx) {
    throw new Error("SettingsSection parts must be rendered within SettingsSection.Root");
  }
  return ctx;
}
function Root(t0) {
  const $ = _c(11);
  const {
    children,
    className
  } = t0;
  const headingId = useId();
  let t1;
  if ($[0] !== headingId) {
    t1 = {
      meta: {
        headingId
      }
    };
    $[0] = headingId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="grid grid-cols-1 gap-x-14 gap-y-8 md:grid-cols-3">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className || $[5] !== headingId || $[6] !== t2) {
    t3 = <section aria-labelledby={headingId} className={className}>{t2}</section>;
    $[4] = className;
    $[5] = headingId;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <SettingsSectionContext value={t1}>{t3}</SettingsSectionContext>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function Header(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div>{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function Title(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    meta: t1
  } = useSettingsSection();
  const {
    headingId
  } = t1;
  let t2;
  if ($[0] !== children || $[1] !== headingId) {
    t2 = <h4 id={headingId} className="scroll-mt-10 text-body-emphasis text-foreground">{children}</h4>;
    $[0] = children;
    $[1] = headingId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function Description(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <p className="mt-1 text-body leading-6 text-muted-foreground">{children}</p>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function Content(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("md:col-span-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export const SettingsSection = {
  Root,
  Header,
  Title,
  Description,
  Content
};